import React from "react";
import { useNavigate } from "react-router-dom";
import {
  FaDoorOpen,
  FaBuilding,
  FaClipboardCheck,
  FaChartBar,
  FaChartPie,
  FaCalendarCheck,
} from "react-icons/fa";

export default function ReportsHome() {
  const navigate = useNavigate();

  const cards = [
    {
      key: "front-office-report",
      title: "Front Office Report",
      desc: "Guest activity, room status, night audit, pickup & more.",
      icon: <FaDoorOpen size={28} />,
    },
    {
      key: "back-office-report",
      title: "Back Office Report",
      desc: "Ledgers, revenue, vouchers, receipts & daily summaries.",
      icon: <FaBuilding size={28} />,
    },
    {
      key: "audit-report",
      title: "Audit Report",
      desc: "Audit trails, void actions, IP log reports.",
      icon: <FaClipboardCheck size={28} />,
    },
    {
      key: "statistical-report",
      title: "Statistical Report",
      desc: "Monthly, yearly, tax & business statistics.",
      icon: <FaChartBar size={28} />,
    },
    {
      key: "graphs-charts",
      title: "Graphs & Charts",
      desc: "Visual analytics for occupancy & revenue.",
      icon: <FaChartPie size={28} />,
    },
    {
      key: "reservation-report",
      title: "Reservation Report",
      desc: "Arrivals, cancellations, no-shows & reservation activity.",
      icon: <FaCalendarCheck size={28} />,
    },
  ];

  return (
    <div className="container py-3">
      {/* Breadcrumb */}
      <div className="mb-2 text-muted small">
        Home / <span className="text-dark fw-semibold">Reports</span>
      </div>

      {/* Page Title */}
      <h3 className="fw-bold mb-4">Reports</h3>

      {/* 3-Column Grid */}
      <div className="row g-4">
        {cards.map((c, index) => (
          <div key={index} className="col-md-4">
            <div
              className="card shadow-sm border-0 h-100"
              style={{
                borderRadius: "12px",
                cursor: "pointer",
                transition: "0.2s",
              }}
              onClick={() => navigate(`/reports/${c.key}`)}
            >
              <div className="card-body d-flex">
                {/* Icon */}
                <div
                  className="me-3 d-flex align-items-start justify-content-center p-3"
                  style={{
                    background: "#F1F5F9",
                    borderRadius: "8px",
                  }}
                >
                  {c.icon}
                </div>

                {/* Text */}
                <div>
                  <h5 className="fw-bold mb-1">{c.title}</h5>
                  <p className="text-muted small mb-0">{c.desc}</p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
